export default {
  state: {
    tim: null,
    isReady: false,
    isLogin: false,
    connectionState: '',
    lastRawMessage: null,
    lastParsedMessage: null
  },
  mutations: {
    set_customerTim (state, val) {
      state.tim = val
    },
    set_customerImReady (state, val) {
      state.isReady = !!val
    },
    set_customerImLogin (state, val) {
      state.isLogin = !!val
    },
    set_customerImConnectionState (state, val) {
      state.connectionState = val || ''
    },
    set_customerImLastRawMessage (state, val) {
      state.lastRawMessage = val || null
    },
    set_customerImLastParsedMessage (state, val) {
      state.lastParsedMessage = val || null
    },
    reset_customerImState (state) {
      state.tim = null
      state.isReady = false
      state.isLogin = false
      state.connectionState = ''
      state.lastRawMessage = null
      state.lastParsedMessage = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/customerIm.js